import ImgTag from "@/components/Helpers/ImgTag";
import browserStorage from "store";

const BannerSection = ({ locale, t }) => {
  const banner = browserStorage.get("popup-banner")
    ? browserStorage.get("popup-banner")[`img-${locale}`]
    : "";
  const paymentIcons = [
    { src: "/imgs/mispay/mispay-widget.svg", alt: "MIS" },
    { src: `/imgs/madfu/new/madfu-logo-${locale}.png`, alt: "Madfu" },
    {
      src: `${process.env.NEXT_PUBLIC_CLOUD_FLAIR}/w=200&h=36,fit=contain,format=auto,quality=100/tamara.png`,
      alt: "Tamara",
    },
    {
      src: `${process.env.NEXT_PUBLIC_CLOUD_FLAIR}/20080&h=36,fit=contain,format=auto,quality=100/tabby.png`,
      alt: "Tabby",
    },
  ];

  return banner ? (
    <ImgTag
      src={banner}
      className="object-contain w-full h-auto px-4 mb-10"
      height={92}
      width={560}
      alt="Tamara Sheet Img!"
    />
  ) : (
    <div className="rounded-xl bg-gradient-to-r from-purple-600 to-indigo-500 p-4 text-center text-white mb-10">
      <h3 className="font-semibold text-lg mb-4">
        {t("Shop and split your purchases into installments!!")}
      </h3>
      <div className="flex justify-center gap-1 flex-wrap">
        {paymentIcons?.map(({ src, alt }) => (
          <div key={alt + src} className="rounded-md">
            <ImgTag
              src={src}
              alt={alt}
              width={70}
              height={30}
              className="h-[18px] w-auto object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BannerSection;
